import _ from 'lodash';
import * as lc from '../../../../../utils/lodashCustom';
import {
  getValueFromRefDataModules,
  getValueFromRefList
} from '../../../../main/reducers/static/states/referenceLists/reducer';

import { restructureTaskExecModel } from '../../TasksExecsService/restructuring';

export function restructureTaskMarkModel(state, data) {
  return {
    marked: lc.get(data, 'marked'),
    buttonMessage: lc.get(data, 'button_message')
  };
}

export function restructureTaskExecStatModel(state, data) {
  return {
    statuses: {
      1: {
        execStatusId: lc.get(data, 'statuses.1.status_id'),
        execStatusTitle: lc.get(data, 'statuses.1.status_title'),
        execCountByStatus: lc.get(data, 'statuses.1.count'),
        execSumByStatus: lc.get(data, 'statuses.1.sum')
      },
      2: {
        execStatusId: lc.get(data, 'statuses.2.status_id'),
        execStatusTitle: lc.get(data, 'statuses.2.status_title'),
        execCountByStatus: lc.get(data, 'statuses.2.count'),
        execSumByStatus: lc.get(data, 'statuses.2.sum')
      },
      3: {
        execStatusId: lc.get(data, 'statuses.3.status_id'),
        execStatusTitle: lc.get(data, 'statuses.3.status_title'),
        execCountByStatus: lc.get(data, 'statuses.3.count'),
        execSumByStatus: lc.get(data, 'statuses.3.sum')
      },
      4: {
        execStatusId: lc.get(data, 'statuses.4.status_id'),
        execStatusTitle: lc.get(data, 'statuses.4.status_title'),
        execCountByStatus: lc.get(data, 'statuses.4.count'),
        execSumByStatus: lc.get(data, 'statuses.4.sum')
      },
      5: {
        execStatusId: lc.get(data, 'statuses.5.status_id'),
        execStatusTitle: lc.get(data, 'statuses.5.status_title'),
        execCountByStatus: lc.get(data, 'statuses.5.count'),
        execSumByStatus: lc.get(data, 'statuses.5.sum')
      },
      6: {
        execStatusId: lc.get(data, 'statuses.6.status_id'),
        execStatusTitle: lc.get(data, 'statuses.6.status_title'),
        execCountByStatus: lc.get(data, 'statuses.6.count'),
        execSumByStatus: lc.get(data, 'statuses.6.sum')
      },
      7: {
        execStatusId: lc.get(data, 'statuses.7.status_id'),
        execStatusTitle: lc.get(data, 'statuses.7.status_title'),
        execCountByStatus: lc.get(data, 'statuses.7.count'),
        execSumByStatus: lc.get(data, 'statuses.7.sum')
      }
    },
    total: {
      desc: lc.get(data, 'total.desc'),
      count: lc.get(data, 'total.count'),
      sum: lc.get(data, 'total.sum')
    },
    totalReservedExecution: {
      desc: lc.get(data, 'total_reserved_execution.desc'),
      count: lc.get(data, 'total_reserved_execution.count'),
      sum: lc.get(data, 'total_reserved_execution.sum')
    },
    disputesFromExecutors: {
      desc: lc.get(data, 'disputes_from_executors.desc'),
      count: lc.get(data, 'disputes_from_executors.count'),
      sum: lc.get(data, 'disputes_from_executors.sum')
    },
    free_executions_slots: {
      desc: lc.get(data, 'free_executions_slots.desc'),
      count: lc.get(data, 'free_executions_slots.count'),
      sum: lc.get(data, 'free_executions_slots.sum')
    }
  };
}

export function restructureTaskModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    status: lc.get(data, 'status'),
    ownerId: lc.get(data, 'owner.id'),
    ownerUserName: lc.get(data, 'owner.username'),
    ownerAvatarPath: lc.get(data, 'owner_profile.avatar_path'),
    taskTypeId: lc.get(data, 'type_id'),
    taskTypeDesc: getValueFromRefDataModules(state, 'tasks.taskTypes').find(
      item => item.value === lc.get(data, 'type_id')
    ).title,
    taskDomain: lc.get(data, 'domain'),
    costExecution: lc.get(data, 'cost_execution'),
    totalCostExecution: lc.get(data, 'total_cost_execution'),
    checkTypeId: lc.get(data, 'check_type'),
    checkTypeDesc: getValueFromRefList(
      state,
      'taskCheckTypes',
      lc.get(data, 'check_type')
    ),
    executorExecutionIntervalDesc: lc.get(
      data,
      'executor_execution_interval_desc'
    ),
    executorExecutionIntervalCheckDesc: lc.get(
      data,
      'executor_execution_interval_check_desc'
    ),
    geoTargetSwitchDesc: lc.get(data, 'geo_target_switch_desc'),
    timeTargetSwitchDesc: lc.get(data, 'time_target_switch_desc'),
    pExecutorEmailConfirmDesc: lc.get(data, 'p_executor_email_confirm_desc'),
    pExecutorMinRatingDesc: lc.get(data, 'p_executor_min_rating_desc'),
    timePerformDesc: lc.get(data, 'time_perform_desc'),
    timeCheckingDesc: lc.get(data, 'time_checking_desc'),
    hasGeoTarget: lc.get(data, 'geo_target_switch') === 1,
    hasTimeTarget: lc.get(data, 'time_target_switch') === 1,
    tasksExecsStat: restructureTaskExecStatModel(
      state,
      lc.get(data, 'exec_stat')
    ),
    taskCommentsStat: {
      dislikes: lc.get(data, 'comment_stat.dislikes'),
      likes: lc.get(data, 'comment_stat.likes'),
      neutral: lc.get(data, 'comment_stat.neutral')
    },
    createdAt: lc.get(data, 'created_at'),
    updatedAt: lc.get(data, 'updated_at')
  };
}

export function restructureTaskAsOwnerModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    desc: lc.get(data, 'desc'),
    status: lc.get(data, 'status'),
    adultContent: lc.get(data, 'adult_content'),
    softwareInstall: lc.get(data, 'software_install'),
    pExecutorMinRating: lc.get(data, 'p_executor_min_rating'),
    reasonsLockedForExecution: lc.get(data, 'reasonsLockedForExecution'),
    ownerId: lc.get(data, 'owner.id'),
    ownerUserName: lc.get(data, 'owner.username'),
    ownerAvatarPath: lc.get(data, 'owner.profile.avatar_path'),
    ownerRating: _.get(data, 'owner_rating_status')
      ? {
          rating: lc.get(data, 'owner_rating_status.rating'),
          ratingStatusTitle: lc.get(data, 'owner_rating_status.title'),
          ratingStatusPoints: lc.get(data, 'owner_rating_status.points'),
          ratingStatusPointsFrom: lc.get(
            data,
            'owner_rating_status.points_from'
          ),
          ratingStatusPointsTo: lc.get(data, 'owner_rating_status.points_to')
        }
      : null,
    taskTypeId: lc.get(data, 'type_id'),
    taskTypeDesc: getValueFromRefDataModules(state, 'tasks.taskTypes').find(
      item => item.value === lc.get(data, 'type_id')
    ).title,
    taskDomain: lc.get(data, 'domain'),
    costExecution: lc.get(data, 'cost_execution'),
    totalCostExecution: lc.get(data, 'total_cost_execution'),
    isFullReserved: lc.get(data, 'is_full_reserved'),
    maxExecutions: lc.get(data, 'max_executions'),
    checkDesc: lc.get(data, 'check_desc'),
    reviewTask: lc.get(data, 'review_task'),
    require_link_in_report: lc.get(data, 'require_link_in_report'),
    require_screenshot_in_report: lc.get(data, 'require_screenshot_in_report'),
    checkTypeId: lc.get(data, 'check_type'),
    checkTypeDesc: getValueFromRefList(
      state,
      'taskCheckTypes',
      lc.get(data, 'check_type')
    ),
    executorExecutionInterval: lc.get(data, 'executor_execution_interval'),
    executorExecutionIntervalDesc: lc.get(
      data,
      'executor_execution_interval_desc'
    ),
    executorExecutionIntervalCheckDesc: lc.get(
      data,
      'executor_execution_interval_check_desc'
    ),
    geoTargetSwitchDesc: lc.get(data, 'geo_target_switch_desc'),
    timeTargetSwitchDesc: lc.get(data, 'time_target_switch_desc'),
    pExecutorEmailConfirmDesc: lc.get(data, 'p_executor_email_confirm_desc'),
    pExecutorMinRatingDesc: lc.get(data, 'p_executor_min_rating_desc'),
    timePerformDesc: lc.get(data, 'time_perform_desc'),
    timeCheckingDesc: lc.get(data, 'time_checking_desc'),
    hasGeoTarget: lc.get(data, 'geo_target_switch') === 1,
    hasTimeTarget: lc.get(data, 'time_target_switch') === 1,
    tasksExecsStat: restructureTaskExecStatModel(
      state,
      lc.get(data, 'exec_stat')
    ),
    taskCommentsStat: {
      dislikes: lc.get(data, 'comment_stat.dislikes'),
      likes: lc.get(data, 'comment_stat.likes'),
      neutral: lc.get(data, 'comment_stat.neutral'),
      total:
        parseInt(lc.get(data, 'comment_stat.dislikes'), 10) +
        parseInt(lc.get(data, 'comment_stat.likes'), 10) +
        parseInt(lc.get(data, 'comment_stat.neutral'), 10)
    },
    statFinishedExecs: lc.get(data, 'stat_finished_execs'),
    free_exec_slots: lc.get(data, 'free_exec_slots'),
    taskQuiz: _.get(data, 'task_qiz'),
    myLastExec: _.get(data, 'my_last_exec')
      ? restructureTaskExecModel(state, lc.get(data, 'my_last_exec'))
      : null,
    markHide: _.get(data, 'mark.HIDE')
      ? restructureTaskMarkModel(state, lc.get(data, 'mark.HIDE'))
      : null,
    markChosen: _.get(data, 'mark.CHOSEN')
      ? restructureTaskMarkModel(state, lc.get(data, 'mark.CHOSEN'))
      : null,
    upListFastenNow: _.get(data, 'up_list_fasten_now')
      ? { andTime: lc.get(data, 'up_list_fasten_now.and_time') }
      : null,
    upListFastenByCategoryNow: _.get(data, 'up_list_fasten_by_category_now')
      ? { andTime: lc.get(data, 'up_list_fasten_by_category_now.and_time') }
      : null,
    upListMarkNow: _.get(data, 'up_list_mark_now')
      ? { andTime: lc.get(data, 'up_list_mark_now.and_time') }
      : null,
    autoLiftInterval: lc.get(data, 'auto_lift_interval'),
    autoLiftQueue: lc.get(data, 'auto_lift_queue'),
    timeTarget: _.get(data, 'time_target')
      ? lc
          .get(data, 'time_target')
          .map(v => ({ weekdays: v.weekdays, times: v.times }))
      : null,
    timeTargetCurrentOptions: _.get(data, 'time_target_current_options'),
    lock: _.get(data, 'lock')
      ? {
          reasonText: lc.get(data, 'lock.reasonText'),
          comment: lc.get(data, 'lock.comment')
        }
      : null,
    liftAt: lc.get(data, 'lift_at'),
    createdAt: lc.get(data, 'created_at'),
    updatedAt: lc.get(data, 'updated_at')
  };
}

export function restructureCreatedTaskModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title')
  };
}

export function restructureUpdateTaskModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    type_id: lc.get(data, 'type_id'),
    locale_code: lc.get(data, 'locale_code'),
    cost_execution: lc.get(data, 'cost_execution'),
    max_executions: lc.get(data, 'max_executions'),
    desc: lc.get(data, 'desc'),
    check_type: lc.get(data, 'check_type'),
    links: lc.get(data, 'task_links').map(value => value.link),
    random_link: lc.get(data, 'random_link'),
    adult_content: lc.get(data, 'adult_content'),
    software_install: lc.get(data, 'software_install'),
    time_checking: lc.get(data, 'time_checking'),
    time_perform: lc.get(data, 'time_perform'),
    executor_execution_interval: lc.get(data, 'executor_execution_interval'),
    executor_execution_interval_check: lc.get(
      data,
      'executor_execution_interval_check'
    ),
    check_desc: lc.get(data, 'check_desc'),
    require_link_in_report: lc.get(data, 'require_link_in_report'),
    require_screenshot_in_report: lc.get(data, 'require_screenshot_in_report'),
    p_executor_email_confirm: lc.get(data, 'p_executor_email_confirm'),
    p_hide_for_black_list: lc.get(data, 'p_hide_for_black_list'),
    p_executor_min_rating: lc.get(data, 'p_executor_min_rating'),
    quiz: lc.get(data, 'task_qiz').map(v => ({ ask: v.ask, answer: v.answer })),
    time_target: lc
      .get(data, 'time_target')
      .map(v => ({ weekdays: v.weekdays, times: v.times })),
    geo_target: lc.get(data, 'geo_target')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksService/restructuring/index.js